/** Company-wide constants. */
export const site = {
  name: 'SeaxDev',
  legalName: 'SeaxDev LLC',
  /** The studio itself is new; the experience behind it is not. */
  foundedYear: 2026,
  experienceSince: 2001,
  url: 'https://www.seaxdev.com/',
  email: 'hello@seaxdev.com',
  location: 'Massachusetts, USA',
  /** Contact form POST target. Override per build with VITE_CONTACT_ENDPOINT. */
  contactEndpoint: 'https://api.jobmand.com/api/public/contact',
} as const;

export const navLinks = [
  { href: '#about', label: '~/about' },
  { href: '#services', label: '~/services' },
  { href: '#stack', label: '~/stack' },
  { href: '#products', label: '~/products' },
  { href: '#contact', label: '~/contact' },
] as const;

/** Years of hands-on experience behind the studio, computed so the copy never goes stale. */
export function yearsCoding(now = new Date()): number {
  return now.getFullYear() - site.experienceSince;
}
